var path = 'app/scripts/modules/ecs/serverGroup/configure/wizard/loadBalancers/loadBalancers.html';
var html = "<div>\n  <ecs-server-group-load-balancer-selector command=\"command\"></ecs-server-group-load-balancer-selector>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/ecs/serverGroup/configure/wizard/loadBalancers/loadBalancers.html
// module id = 1618
// module chunks = 0